import api from "@/services/api"
import { useQuery } from "@tanstack/vue-query"

import type { RecursivelyConvertDatesToStrings } from "@/utils/typeUtilities"

type BusinessFundingConfig = {
  date: Date
  fundedAmount: number
  fundedNumber: number
  contactPhone: string
  contactEmail: string
}
export const retrieveBusinessFundingConfig = async () => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<BusinessFundingConfig>
  >("/business-funding-config/")
  return {
    ...body,
    date: DateFns.parseISO(body.date),
  }
}

export const useBusinessFundingConfig = () =>
  useQuery({
    queryKey: ["businessFundingConfig"] as const,
    queryFn: retrieveBusinessFundingConfig,
    staleTime: Infinity,
  })
